import { LogLevel } from 'ia-react-core/~/interfaces/LogLevel';

const consoleReporter = (namespace: string, level: LogLevel, ...args: unknown[]) => {
  // eslint-disable-next-line no-console
  console[level](`[${namespace}]`, ...args);
};

export default consoleReporter;
